import React from 'react';
import PropTypes from 'prop-types';

import RemoveInvitedUserAction from 'Containers/RemoveInvitedUserAction';
import RemoveStudentFromClassAction from 'Containers/RemoveStudentFromClassAction';
import ResendInviteAction from 'Containers/ResendInviteAction';
import UsersListAction from 'Components/UsersListAction';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { ROUTES } from 'Settings/route-strings';

const UsersListActions = ({ actions, data, groupId, groupType }) => {
  return (
    <div className="ListRow__actions">
      {actions.map(action => {
        const actionProps = {
          user: data,
          groupId,
          groupType,
          key: action,
        };
        switch (action) {
          case 'edit':
            return (
              <UsersListAction
                {...actionProps}
                label={
                  <ConnectedFormattedMessage id="users_list.action_labels.edit" />
                }
                iconType="pencil"
                to={`${ROUTES.USERS}/${data.id}`}
              />
            );
          case 'resendInvite':
            return <ResendInviteAction {...actionProps} />;
          case 'removeInvitedUser':
            return <RemoveInvitedUserAction {...actionProps} />;
          case 'removeStudentFromClass':
            return <RemoveStudentFromClassAction {...actionProps} />;
          default:
            return null;
        }
      })}
    </div>
  );
};

UsersListActions.propTypes = {
  actions: PropTypes.array.isRequired,
  data: PropTypes.object,
  groupId: PropTypes.number,
  groupType: PropTypes.string,
};

export default UsersListActions;
